export const statusColors = {
  red: ['11', '19', '20', '22', '23', '26', '27'],
  green: ['46', '51', '52', '57'],
  yellow: ['10', '30', '40', '41', '42', '43', '45', '50'],
  gray: ['70'],
  purple: ['60'],
} as { [key: string]: string[] };

export enum statusColorCodes {
  red = '#C10606',
  green = '#10773A',
  yellow = '#F6A609',
  gray = '#52575C',
  purple = '#470BA9',
}
